module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av752-4a71f3376828757ae2b26eadbc84154a.jpg";